import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {
  getAllProducts,
  getSubCategory
} from '../../../store/actions/user/User';
import { connect } from 'react-redux';
import SkeletonLoad from '../Preloader/SkeletonLoad';
import { getVendorDetails } from '../../../store/actions/shared/Shared';
import GMProducts from './GMproduct';
import Carousel from 'react-elastic-carousel';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  }
}));

function NavTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [thePosition, setThePosition] = React.useState(1);
  const [rightBackgroundImage, setRightBackgroundImage] = React.useState(
    props.match.params.category === 'Grocery'
      ? 'https://overseepos.in/images/posfor/banner.jpg'
      : props.match.params.category === 'Medicine'
      ? 'https://craftmediabucket.s3.amazonaws.com/uploads/_auto1800/blue-pill-background.png'
      : props.match.params.category === 'Pets'
      ? 'https://cache.desktopnexus.com/cropped-wallpapers/2547/2547341-1536x864-[DesktopNexus.com].jpg?st=aqvMdjwovmwbW9dy-TZJvg&e=1600637650'
      : props.match.params.category === 'Vegetables'
      ? 'https://images5.alphacoders.com/368/thumb-1920-368825.jpg'
      : 'https://images2.alphacoders.com/887/thumb-1920-887494.jpg'
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const onPressCategory = () => {
    window.scrollTo({ top: 401, behavior: 'smooth' });
  };
  useEffect(() => {
    var uid = props.match.params.uid;
    props.getVendorDetails(uid);
    props.getAllProducts(props.match.params.category, props.match.params.uid);
    props.getSubCategory(props.match.params.category, props.match.params.uid);
    document.addEventListener('scroll', () => {
      if (window.scrollY > 329) {
        setThePosition(true);
      } else {
        setThePosition(false);
      }
    });
    window.scrollTo(0, 0);
  }, []);

  var difference, closeHours;

  if (props.vendor.closetime) {
    if (props.vendor.closetime.includes('pm')) {
      var openHours, openMin;
      closeHours = parseInt(
        props.vendor.closetime.substring(0, props.vendor.closetime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? closeHours : closeHours + 12;
      const closeMin = parseInt(
        props.vendor.closetime.substring(
          props.vendor.closetime.indexOf(':') + 1,
          props.vendor.closetime.indexOf(':') + 3
        )
      );
      // const openHours = (parseInt(props.vendor.opentime.substring(0,props.vendor.opentime.indexOf(':')))+12)*60
      // const openMin   = parseInt(props.vendor.opentime.substring(props.vendor.opentime.indexOf(':')+1,props.vendor.opentime.indexOf(':')+3))
      if (props.vendor.opentime.includes('am')) {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      }
      closeHours *= 60;
      const currentHours = new Date().getHours() * 60;
      const currentMinutes = new Date().getMinutes();

      const today = new Date().getDay().toString();
      if (props.vendor.days && props.vendor.days.indexOf(today) === -1) {
        difference = -1;
      } else if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    } // if time in A.M.
    else {
      closeHours = parseInt(
        props.vendor.closetime.substring(0, props.vendor.closetime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? 0 : closeHours;
      const closeMin = parseInt(
        props.vendor.closetime.substring(
          props.vendor.closetime.indexOf(':') + 1,
          props.vendor.closetime.indexOf(':') + 3
        )
      );
      const currentHours = new Date().getHours() * 60;
      const currentMinutes = new Date().getMinutes();
      if (props.vendor.opentime.includes('am')) {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      }

      closeHours *= 60;

      const today = new Date().getDay().toString();
      if (props.vendor.days && props.vendor.days.indexOf(today) === -1) {
        difference = -1;
      } else if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    }
  }

  var prods, subs;
  if (props.match.params.category === 'Grocery') {
    prods = props.products.grocery_products;
    subs = props.products.grocery_subcategory;
  } else if (props.match.params.category === 'Medicine') {
    prods = props.products.medicine_products;
    subs = props.products.medicine_subcategory;
  } else if (props.match.params.category === 'Pets') {
    prods = props.products.pets_products;
    subs = props.products.pets_subcategory;
  } else if (props.match.params.category === 'Vegetables') {
    prods = props.products.vegetables_products;
    subs = props.products.vegetables_subcategory;
  }
  var superCategs = [];
  subs.forEach((sub) => {
    var superFromSubs = sub.substring(sub.indexOf('(') + 1, sub.indexOf(')'));
    if (superCategs.indexOf(superFromSubs) === -1) {
      superCategs.push(superFromSubs);
    }
  });

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 }
  ];

  const { auth } = props;
  return (
    <div className={classes.root}>
      <div
        className=""
        style={{
          marginBottom: '0',
          paddingRight: '0',
          paddingLeft: '0',
          marginTop: '3.4em',
          background: 'white',
          marginRight: '0px'
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div
              className="bgImage special-background"
              style={{
                height: '400px',
                backgroundImage: `url(${rightBackgroundImage})`,
                boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
                backgroundSize: 'cover',
                resize: 'both',
                borderBottom: '1px solid #00000010',
                paddingBottom: '1px',
                marginBottom: 0
              }}
            >
              {!props.store_loader ? (
                <>
                  <div className="container-fluid">
                    <div
                      className="row"
                      id="shiftRight"
                      style={{ marginTop: '32px' }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          background: '#ffffff',
                          marginLeft: '-20px',
                          paddingRight: '5px',
                          paddingLeft: '15px',
                          paddingTop: '15px',
                          paddingBottom: '15px'
                        }}
                        className="col-12 col-sm-5 shadow-lg"
                      >
                        <div
                          className="col-5 col-sm-5"
                          style={{ textAlign: 'left' }}
                        >
                          <img
                            alt="store"
                            style={{ height: '140px', borderRadius: '3px' }}
                            className="shadow-lg"
                            src={props.vendor.image}
                          />
                        </div>
                        <div
                          className="col-7 col-sm-10 "
                          style={{ textAlign: 'initial' }}
                        >
                          <div>
                            <h3
                              className="vendorname"
                              style={{
                                fontWeight: 'bold',
                                textTransform: 'capitalize'
                              }}
                            >
                              {props.vendor.name}
                            </h3>
                            <h6
                              style={{
                                color: 'secondary',
                                paddingTop: '5px',
                                paddingBottom: '1px',
                                fontWeight: '400',
                                fontSize: '16px',
                                lineHeight: '16px'
                              }}
                            >
                              <i
                                className="fa fa-map-marker"
                                style={{
                                  color: 'secondary',
                                  marginRight: '10px',
                                  fontWeight: '300',
                                  fontSize: '16px',
                                  lineHeight: '16px'
                                }}
                              ></i>
                              {props.vendor.location}
                            </h6>
                            <h6
                              style={{
                                color: 'secondary',
                                paddingTop: '5px',
                                paddingBottom: '1px',
                                fontWeight: '400',
                                fontSize: '14px',
                                lineHeight: '16px',
                                display: 'flex'
                              }}
                            >
                              <i
                                className="fa fa-tag"
                                style={{
                                  color: 'secondary',
                                  marginRight: '7px',
                                  fontWeight: '300',
                                  fontSize: '14px',
                                  lineHeight: '16px'
                                }}
                              ></i>{' '}
                              <div>
                                {superCategs &&
                                  superCategs.map((superCategory) => (
                                    <span key={superCategory}>
                                      {' '}
                                      •{superCategory}
                                    </span>
                                  ))}
                              </div>
                            </h6>
                            <h5
                              style={{
                                color: 'secondary',
                                paddingTop: '5px',
                                paddingBottom: '1px',
                                fontWeight: '300',
                                fontSize: '16px',
                                lineHeight: '16px',
                                display: 'flex'
                              }}
                            >
                              <i
                                className="fa fa-clock-o"
                                style={{
                                  color: 'secondary',
                                  marginRight: '6px',
                                  fontWeight: '300',
                                  fontSize: '16px',
                                  lineHeight: '16px'
                                }}
                              ></i>{' '}
                              <b>
                                {/* {this.props.vendor.opentime} to{this.props.vendor.closetime}*/}{' '}
                                {(
                                  props.match.params.distance * 1.5 +
                                  15
                                ).toFixed(2)}{' '}
                                mins | {props.match.params.distance}Km |{' '}
                                {difference > 0 ? (
                                  <b style={{ color: '#36BA92' }}>
                                    <i className="fa fa-check"></i> Open
                                  </b>
                                ) : (
                                  <b style={{ color: '#ce1d27' }}>
                                    <i className="fa fa-times"></i> Closed
                                  </b>
                                )}
                              </b>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <SkeletonLoad />
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid"
        style={
          thePosition === false
            ? { zIndex: '99' }
            : { position: 'sticky', zIndex: '99', top: '55px' }
        }
      >
        <div className="row">
          <AppBar position="sticky">
            <Tabs
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="nav tabs example"
              className={classes.tabDecor}
              style={{ background: 'white' }}
            >
              {superCategs &&
                superCategs.map((superCategory) => (
                  <LinkTab
                    onClick={() => {
                      onPressCategory();
                    }}
                    label={superCategory}
                    style={{
                      textDecoration: 'none',
                      color: 'black',
                      borderRight: '0.5px solid grey',
                      paddingLeft: '25px'
                    }}
                    {...a11yProps(superCategs.indexOf(superCategory))}
                  />
                ))}
              {/* <LinkTab label="Beer" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey',paddingLeft:'25px'}}  {...a11yProps(0)} />
          <LinkTab label="Cider" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey'}} href="/" {...a11yProps(1)} />
          <LinkTab label="White Wine" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey'}} href="/" {...a11yProps(2)} />
          <LinkTab label="Red Wine" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey'}} href="/" {...a11yProps(3)} />
          <LinkTab label="Champagne and Sparklings" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey'}} href="/" {...a11yProps(4)} />
          <LinkTab label="Spirits" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey'}} href="/" {...a11yProps(5)} /> */}
              {/* <LinkTab label="Mixed Drinks" style={{textDecoration:'none',color:'black', borderRight:'0.5px solid grey'}} href="/ " {...a11yProps(6)} /> */}
            </Tabs>
          </AppBar>
        </div>
      </div>
      {superCategs.map((superCategory) => (
        <TabPanel value={value} index={superCategs.indexOf(superCategory)}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-12  order-1 order-lg-2 mb-5 mb-lg-0 "
                id="scrollDiv"
                style={{
                  paddingLeft: '0',
                  marginTop: '-1em',
                  paddingTop: '1em'
                }}
              >
                <div className="row" style={{ paddingLeft: '18px' }}>
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        textAlign: 'initial',
                        color: 'rgb(0, 0, 0)',
                        fontWeight: 400,
                        textTransform: 'capitalize'
                      }}
                    >
                      Products (
                      {
                        prods.filter(
                          (product) => product.super_category === superCategory
                        ).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textAlign: 'start',
                      marginTop: '-20px',
                      color: '#112c50'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-12">
                    {subs.map((subName) =>
                      subName.includes(superCategory) ? (
                        <div
                          className="container-fluid mb-3"
                          id={subName}
                          style={{
                            margin: '0px',
                            paddingRight: '0px',
                            paddingLeft: '2px'
                          }}
                        >
                          <div className="row">
                            <div
                              className="col-12"
                              style={{ textAlign: 'initial' }}
                            >
                              <h5
                                style={{
                                  fontWeight: '400',
                                  color: 'rgb(0, 0, 0)',
                                  paddingLeft: '14px',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {subName.slice(0, subName.indexOf('('))}
                              </h5>
                            </div>
                          </div>
                          <hr />
                          {prods.filter(
                            (product) =>
                              product.super_category === superCategory &&
                              product.sub_category === subName
                          ).length ? (
                            <Carousel breakPoints={breakPoints}>
                              {prods
                                .filter(
                                  (product) =>
                                    product.super_category === superCategory &&
                                    product.sub_category === subName
                                )
                                .map((product) =>
                                  product.sub_category === subName ? (
                                    <GMProducts
                                      pid={product.pid}
                                      name={product.name}
                                      image={product.image}
                                      description={product.description}
                                      product={product}
                                      stock={product.stock}
                                      price={product.price}
                                      history={props.history}
                                    />
                                  ) : null
                                )}
                            </Carousel>
                          ) : null}
                        </div>
                      ) : (
                        ''
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
      ))}{' '}
      <br /> <br />
      <div className="container-fluid">
        <div className="row ">
          <div
            className="myBanner"
            style={{ textAlign: 'initial', marginBottom: '-1px' }}
          >
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h4 className="text-white">
                    Get anything from anywhere, at anytime
                  </h4>
                </div>
                <div className="col-12">
                  <p className="text-white">
                    Life is too short to waste it in finding the product you
                    need from thousands of products in your Favorite
                    supermarket, just click the photo of the product you need
                    and get it to deliver with Grospick.
                  </p>
                </div>
                <div className="col-12">
                  <p className="text-white">
                    Our trained shoppers will shop for you in the grocery store
                    and deliver to your home at the exact same price as the
                    stores. Want to eat at your favorite restaurant, but they
                    don't deliver? We will pick up your food and deliver it in
                    minutes. This is a new way of life. The very best in your
                    city, delivered in minutes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container"
            style={{
              color: '#fff',
              background: '#fff',
              height: '1px',
              width: '92%'
            }}
          ></div>
        </div>
        <div className="row">
          <div
            className="myBanner"
            style={{
              backgroundImage:
                'url(../../../../../img/footer.png), linear-gradient( 0deg, rgb(19, 25, 41) 0%, rgb(29, 36, 60) 100%)',
              backgroundPosition: 'bottom right'
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-1 col-md-1 mt-5">
                  <img src="../../../../../img/logo.png" alt="" />
                </div>
                <div className="col-2 col-md-2 footer-categorie">
                  {!auth ? (
                    <>
                      <h5
                        className="text-white footer-font"
                        style={{ paddingBottom: '3px', fontWeight: '700' }}
                      >
                        CUSTOMERS
                      </h5>
                      <Link
                        to="/vendor/login"
                        style={{ textDecoration: 'none' }}
                      >
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            paddingTop: '2px',
                            marginBottom: '4px',
                            fontWeight: 400
                          }}
                        >
                          Vendor Login
                        </p>
                      </Link>
                    </>
                  ) : (
                    ''
                  )}
                  {!auth ? (
                    <Link to="/admin/login" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Admin Login
                      </p>
                    </Link>
                  ) : (
                    ''
                  )}
                  <Link to="" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Community service
                    </p>
                  </Link>
                </div>
                <div className="col-3 col-md-2" style={{ textAlign: 'left' }}>
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GROSPICK
                  </h5>
                  <Link to="./about" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      About
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Jobs
                    </p>
                  </Link>
                  <Link to="./contact" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Contact Us
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Terms & Conditions
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        fontWeight: 400
                      }}
                    >
                      Privacy Policy
                    </p>
                  </Link>
                </div>
                <div className="col-3 col-md-2" style={{ textAlign: 'left' }}>
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GET IN TOUCH
                  </h5>
                  <Link to="./contact" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      Email
                    </p>
                  </Link>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://twitter.com/grospick"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Twitter
                    </p>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/Grospick-108163027510472/"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Facebook
                    </p>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/grospicker/?hl=en"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Instagram
                    </p>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="//#endregion"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        fontWeight: 400
                      }}
                    >
                      LinkedIn
                    </p>
                  </a>
                </div>
                <div
                  className="col-3 col-md-2 footer-categorie2"
                  style={{
                    textAlign: 'left',
                    paddingRight: '0px',
                    paddingLeft: '0px'
                  }}
                >
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GET OUR APP
                  </h5>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-android"
                        style={{ paddingRight: '3px' }}
                      ></i>{' '}
                      Android
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-apple"
                        style={{ paddingRight: '3px' }}
                      ></i>{' '}
                      Ios
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-desktop"
                        style={{ paddingRight: '4px' }}
                      ></i>{' '}
                      Desktop
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  getAllProducts: (category, uid) => dispatch(getAllProducts(category, uid)),
  getSubCategory: (category, uid) => dispatch(getSubCategory(category, uid)),
  getVendorDetails: (uid) => dispatch(getVendorDetails(uid))
});
const mapStateWithProps = (state) => ({
  vendors: state.user.vendors,
  products: state.user,
  vendor: state.shared.vendor,
  auth: state.user.auth,
  loader: state.ui.user_loading,
  store_loader: state.ui.store_loader
});
export default connect(mapStateWithProps, mapDispatchToProps)(NavTabs);
